/** Textes écran succès tracevélo (FR). */
export const traceveloFrSuccessCopy = {
  breadcrumbOrder: 'Ordre',
  breadcrumbReceive: 'Recevoir des fonds',
  title: 'Recevoir des fonds',
  paidLabel: 'Payé',
  deliveryLabel: 'Livraison',
  deliveryZone: 'Zone de livraison',
  offer: 'Offert',
  metro: 'France métropolitaine',
  secureFunds: 'Réception sécurisée des fonds',
  includesProtection: '€ y compris les frais de protection du vendeur',
  cta: 'Recevoir des fonds',
  trustTitle: 'Livraison au client avec paiement sécurisé.',
  trustLine1: "Envoyez cet article directement chez l'acheteur à domicile ou au point de retrait le plus proche.",
  trustLine2: "Profitez d'une transaction et d'un processus sécurisés.",
  loading: 'Chargement…',
};

